export { default as TreatingVolumeBar } from './TreatingVolumeBar';
